
import { SvgTypesProps } from '@/shared/types/SvgTypes';

export function IconExitApp({
  fill = 'var(--sapphire-20)',
  width = 16,
  height = 18,
}: SvgTypesProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 1H2.5C1.67157 1 1 1.67157 1 2.5V15.5C1 16.3284 1.67157 17 2.5 17H9.5M5 9H15M15 9L11 13M15 9L11 5" stroke={fill} strokeWidth="1.5" strokeLinejoin="round"/>
    </svg>
  );
}
